import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { useLogoutConfirm } from '@/composables/useLogoutConfirm'
import useGlobal from '@/composables/useGlobal'
import { storage } from '@/utils/session'
import { isLp, isAdmin } from '@access/permissions'
import { useUserStore } from '@/stores/user'
import {
  logoutResource,
} from '@/services/auth.service'

import {
PROFILE_PAGE_NAME,
} from '@/components/pages/cabinet/routes'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBar',
  setup(__props, { expose: __expose }) {
  __expose();

const store = useUserStore()

const storeRefresher = computed(() => useUserStore())

storeRefresher.value.getUserData()

const profile = computed(() => store.profile)

const { $t } = useGlobal()
const sidebar = ref(null)

// const profile = ref({
//   firstName: 'name',
//   lastName: 'lastName',
//   avatar: null,
// })

const menuData = ref([
  {
    title: 'Информ. панель',
    id: 'info',
    icon: 'i-info-panel-icon',
    link: '/',
    isShow: true,

  },
  {
    title: 'Информ. панель',
    id: 'candidate-info',
    icon: 'i-info-panel-icon',
    link: '/',
    isShow: true,

  },
])
function closeSidebar() {
  sidebar.value.classList.remove('is-open')
}
function toggleSidebar() {
  sidebar.value.classList.toggle('is-open')
}

const logout = async () => {
  const question = $t('Are you sure you want to go out?')
  const logout = true
  try {
      await useLogoutConfirm(question)
      const { data: { redirectLink } } = (await logoutResource.execute({}, {}))
      window.location.href = redirectLink
  } catch (e) {
    return Promise.reject(e)
  }
}


const __returned__ = { store, storeRefresher, profile, $t, sidebar, menuData, closeSidebar, toggleSidebar, logout, ref, computed, get useLogoutConfirm() { return useLogoutConfirm }, get useGlobal() { return useGlobal }, get storage() { return storage }, get isLp() { return isLp }, get isAdmin() { return isAdmin }, get useUserStore() { return useUserStore }, get logoutResource() { return logoutResource }, get PROFILE_PAGE_NAME() { return PROFILE_PAGE_NAME } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})